import { render, staticRenderFns } from "./ConfirmationIntegration.vue?vue&type=template&id=68b4e581"
import script from "./ConfirmationIntegration.vue?vue&type=script&lang=js"
export * from "./ConfirmationIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports